// Modules for handling calls to API backend.
import { getCookie } from "@/utils/cookies.js";

// Make api calls to fc-congress.
export class CongressService {
  static get(path) {
    return fetch(process.env.VUE_APP_CONGRESS + path).then(response => {
      if (!response.ok) {
        throw new Error(`GET failed - status ${response.status}`);
      } else {
        return response.json();
      }
    });
  }

  static paginate(url) {
    return fetch(url, {
      credentials: "include",
      mode: "cors"
    }).then(response => {
      if (!response.ok) {
        throw new Error(`GET failed - status ${response.status}`);
      } else {
        return response.json();
      }
    });
  }
}

// Make api calls to fc-platform.
export class PlatformService {
  static get(path) {
    return fetch(process.env.VUE_APP_PLATFORM + path, {
      credentials: "include",
      mode: "cors"
    }).then(response => {
      if (!response.ok) {
        throw new Error(`GET failed - status ${response.status}`);
      } else {
        return response.json();
      }
    });
  }

  static post(path, data) {
    const csrftoken = getCookie("csrftoken");

    return fetch(process.env.VUE_APP_PLATFORM + path, {
      credentials: "include",
      method: "POST",
      mode: "cors",
      body: data,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRFToken": csrftoken
      }
    }).then(response => {
      if (!response.ok) {
        throw new Error(`POST failed - status ${response.status}`);
      } else {
        return response.json();
      }
    });
  }

  static patch(path, data) {
    const csrftoken = getCookie("csrftoken");
    return fetch(process.env.VUE_APP_PLATFORM + path, {
      credentials: "include",
      method: "PATCH",
      mode: "cors",
      body: data,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRFToken": csrftoken
      }
    }).then(response => {
      if (!response.ok) {
        throw new Error(`PATCH failed - status ${response.status}`);
      } else {
        return response.json();
      }
    });
  }

  static delete(path) {
    const csrftoken = getCookie("csrftoken");
    return fetch(process.env.VUE_APP_PLATFORM + path, {
      credentials: "include",
      method: "DELETE",
      mode: "cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRFToken": csrftoken
      }
    }).then(response => {
      if (!response.ok) {
        throw new Error(`Delete failed - status ${response.status}`);
      } else {
        return response.json();
      }
    });
  }

  static paginate(url) {
    return fetch(url, {
      credentials: "include",
      mode: "cors"
    }).then(response => {
      if (!response.ok) {
        throw new Error(`GET failed - status ${response.status}`);
      } else {
        return response.json();
      }
    });
  }
}
